import { OnScreenModal } from '@/components/ui/OnScreenModal'
import type { ChargebackConfirmModalProps } from '../../types/components'
import {
  CHARGEBACK_DETAIL_PRIMARY_BUTTON_CLASS,
  CHARGEBACK_DETAIL_SECONDARY_BUTTON_CLASS,
} from '../../constants/chargebackDetailConstants'

/** Shared confirm shell so every chargeback dialog keeps the same header/footer chrome. */
export function ChargebackConfirmModal({
  title,
  message,
  primaryLabel,
  secondaryLabel = 'Cancel',
  onPrimary,
  onCancel,
  panelDataTestId,
  primaryDataTestId,
  children,
}: ChargebackConfirmModalProps) {
  return (
    <OnScreenModal
      isOpen
      title={title}
      // Short confirms use the compact width; a custom body (file lists) needs room.
      maxWidth={children ? 'max-w-lg' : 'max-w-md'}
      onClose={onCancel}
      panelDataTestId={panelDataTestId}
      footer={
        <div className="flex items-center justify-center gap-3">
          <button
            type="button"
            onClick={onPrimary}
            className={CHARGEBACK_DETAIL_PRIMARY_BUTTON_CLASS}
            data-testid={primaryDataTestId}
          >
            {primaryLabel}
          </button>
          <button
            type="button"
            onClick={onCancel}
            className={CHARGEBACK_DETAIL_SECONDARY_BUTTON_CLASS}
          >
            {secondaryLabel}
          </button>
        </div>
      }
    >
      {children ?? (
        <div className="px-1 py-5 text-center">
          <p className="text-sm leading-relaxed text-slate-700">{message}</p>
        </div>
      )}
    </OnScreenModal>
  )
}
